import React from 'react';
import {observer} from 'mobx-react';
import './component.scss';
import {ITsSnapshotReminderController} from './controller';
import isEqual from 'lodash/isEqual';

export interface TsSnapshotReminderProps {
    controller: ITsSnapshotReminderController;
    message: string;
}

interface TsSnapshotReminderState {
    containerStyle: React.CSSProperties;
}

class TsSnapshotReminderComponent extends React.Component<TsSnapshotReminderProps, TsSnapshotReminderState> {
    private reminderRef: React.RefObject<HTMLDivElement>;

    constructor(props: TsSnapshotReminderProps) {
        super(props);
        this.reminderRef = React.createRef<HTMLDivElement>();
        this.state = {
            containerStyle: {}
        };
    }

    componentDidMount() {
        this.updateContainerStyle();
    }

    componentDidUpdate(prevProps: Readonly<TsSnapshotReminderProps>, prevState: Readonly<TsSnapshotReminderState>) {
        if (this.reminderRef.current) {
            const newStyle = this.props.controller.getContainerStyle(
                this.reminderRef.current as HTMLDivElement
            ) as React.CSSProperties;
            if (!isEqual(prevState.containerStyle, newStyle)) {
                this.updateContainerStyle();
            }
        }
    }

    updateContainerStyle() {
        if (this.reminderRef.current) {
            const newStyle = this.props.controller.getContainerStyle(
                this.reminderRef.current as HTMLDivElement
            ) as React.CSSProperties;

            // Only update if style actually changed
            if (!isEqual(this.state.containerStyle, newStyle)) {
                this.setState({containerStyle: newStyle});
            }
        }
    }

    render(): JSX.Element | null {
        const {controller, message} = this.props;
        const {containerStyle} = this.state;

        if (!controller.visible) {
            return null;
        }

        return (
            <div
                ref={this.reminderRef}
                className={`ts-snapshot-reminder ${controller.popDirection === 'left' ? 'pop-left' : 'pop-center'}`}
                style={containerStyle}
                dir={controller.dir}>
                <div className={`message ${controller.dir === 'rtl' ? 'rtl' : ''}`}>{message}</div>
                <div
                    className={`close-button ${controller.dir === 'rtl' ? 'rtl' : ''}`}
                    onClick={controller.closeClicked}
                />
            </div>
        );
    }
}

export const TsSnapshotReminder = observer(TsSnapshotReminderComponent);
